import React from "react";
import { Navigate } from "react-router-dom";
import { connect } from "react-redux";
import { firebaseConnect } from "react-redux-firebase";
import { get } from "lodash";
import {
  canAccessOnboardingSession,
  showOnboardingNav,
} from "../../../../../../utils/onboarding/onboardingAccess";
import { isCharityFirebasePathLoaded } from "../../../../../../utils/onboarding/dashboardSequencing";
import OnboardingDashboardLoader from "../onboardingDashboardLoader";

interface Props {
  children: React.ReactElement;
  charityId: string;
  isSuperadmin: boolean;
  isOnboardingOperator: boolean;
  onboardingRequiredLoaded: boolean;
  onboardingRequired: boolean;
}

const OnboardingAccessGateInner: React.FC<Props> = ({
  children,
  charityId,
  isSuperadmin,
  isOnboardingOperator,
  onboardingRequiredLoaded,
  onboardingRequired,
}) => {
  if (!charityId || !onboardingRequiredLoaded) {
    return <OnboardingDashboardLoader />;
  }

  if (
    !canAccessOnboardingSession(
      { isSuperadmin, isOnboardingOperator },
      onboardingRequired
    )
  ) {
    return <Navigate to="/contacts" replace />;
  }

  return children;
};

const mapStateToProps = (state: any) => {
  const { user, firebase } = state;
  const charityId = user.currentCharity?.id || "";
  const onboardingRequiredLoaded = isCharityFirebasePathLoaded(
    firebase,
    charityId,
    "onboardingRequired"
  );

  return {
    charityId,
    isSuperadmin: user.isSuperadmin,
    isOnboardingOperator: user.isOnboardingOperator,
    onboardingRequiredLoaded,
    onboardingRequired: onboardingRequiredLoaded
      ? get(firebase, `data.${charityId}.onboardingRequired`) === true
      : false,
  };
};

const OnboardingAccessGate = connect(mapStateToProps)(
  firebaseConnect((_props: any, store: any) => {
    const charityId = store.getState().user.currentCharity?.id;
    if (!charityId) {
      return [];
    }
    return [`${charityId}/onboardingRequired`];
  })(OnboardingAccessGateInner)
);

export { showOnboardingNav };
export default OnboardingAccessGate;
